<template><div><h1 id="liste-der-lagerleiterinnen" tabindex="-1"><a class="header-anchor" href="#liste-der-lagerleiterinnen"><span>Liste der LagerleiterInnen</span></a></h1>
<p>Liste der LagerleiterInnen — Liste der LagerleiterInnen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Drucken einer Liste aller dem System bekannten Lagerleiter, die den gewählten Parametern entsprechen. Die Liste enthält den Veranstaltungskopf mit allen wesentlichen Angaben zur Veranstaltung sowie die Adressdaten der Lagerleitung.</p>
<p>Pfad: <code v-pre>Veranstaltungen → Datenausgabe → Liste der LagerleiterInnen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Jahr/Nummer von</dt>
<dd>Identifikator der Veranstaltung (kleinster)</dd>
<dt>Jahr/Nummer bis</dt>
<dd>Identifikator der Veranstaltung (grösster)</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Liste druckt den Veranstaltungskopf mit allen wesentlichen Angaben zur Veranstaltung und anschliessend daran die Adressdaten der Lagerleitung mit den Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AdressNr.</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Name</td>
</tr>
<tr>
<td>Vorname</td>
<td>Vorname</td>
</tr>
<tr>
<td>PLZ</td>
<td>Postleitzahl</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort</td>
</tr>
<tr>
<td>Strasse+Nr</td>
<td>Strasse und Hausnummer</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">                                 Veranstaltung</span>
<span class="line">Jahr/Nr: 2000/10   Preis: 410.00    Alter.: 12-14 Anzahl:   1- 20 14.02.00 mhe</span>
<span class="line">von-bis: 15.07.2000-22.07.2000      Anm.: P   0 D  20 B  20 T  19</span>
<span class="line">Bezeich: Klimalager</span>
<span class="line">Leitung:  3,433,146 Künzler Daniel, Zürich 8004, Eichbühlstr Tel: 01/4935867</span>
<span class="line"></span>
<span class="line">AdressNr.. Name                      Vorname         PLZ  Ort</span>
<span class="line">Strasse+Nr</span>
<span class="line">-------------------------------------------------------------------------</span>
<span class="line"> 3,433,146 Künzler                   Daniel          8004 Zürich</span>
<span class="line">Eichbühlstrasse   62</span>
<span class="line"></span>
<span class="line">                                 Veranstaltung</span>
<span class="line">Jahr/Nr: 2000/11A  Preis: 715.00    Alter.: 10-16 Anzahl:   1- 56 14.02.00 mhe</span>
<span class="line">von-bis: 10.07.2000-22.07.2000      Anm.: P   0 D  46 B  44 T  41 14.02.00 mhe</span>
<span class="line">Bezeich: IndianerInnenlager A</span>
<span class="line">Leitung:  3,598,029 Elmer Arthur, Matt 8766, Bündnerblick 0  Tel:</span>
<span class="line"></span>
<span class="line">AdressNr.. Name                      Vorname         PLZ  Ort</span>
<span class="line">Strasse+Nr</span>
<span class="line">-------------------------------------------------------------------------</span>
<span class="line"> 3,598,029 Elmer                     Arthur          8766 Matt</span>
<span class="line">Bündnerblick</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


